import { CHANNELS } from "../../shared/channels";
import { UserSettings, WebTab } from "../../shared/types";
import { call } from "../bridge";
import { byId } from "../dom";
import { applyNavOrder, onViewHidden, onViewShown, setWebTabs } from "../navigation";
import { cachedSettings } from "../settings_cache";

let activeTabId = "";
let tabs: WebTab[] = [];
let placeTimer = 0;

function hostBounds(): { x: number; y: number; width: number; height: number } | null {
  const box = byId("web-host").getBoundingClientRect();
  if (box.width < 80 || box.height < 80) return null;
  return {
    x: Math.round(box.left),
    y: Math.round(box.top),
    width: Math.round(box.width),
    height: Math.round(box.height)
  };
}

function placeActiveTab(): void {
  if (!activeTabId) return;
  window.clearTimeout(placeTimer);
  const send = () => {
    if (!activeTabId) return;
    const bounds = hostBounds();
    if (!bounds) return;
    call(CHANNELS.tabsShow, activeTabId, bounds);
  };
  requestAnimationFrame(() => {
    send();
    requestAnimationFrame(send);
  });
  placeTimer = window.setTimeout(send, 50);
}

function openTab(tabId: string): void {
  activeTabId = tabId;
  byId("web-title").textContent = tabs.find((tab) => tab.id === tabId)?.name ?? "";
  placeActiveTab();
}

export function renderTabButtons(settings: UserSettings): void {
  tabs = settings.webTabs || [];
  setWebTabs(tabs);
  void applyNavOrder(settings.tabOrder);
}

export async function setupWebView(): Promise<void> {
  if (!window.bridge) {
    renderTabButtons(await cachedSettings());
    return;
  }
  onViewShown("web", openTab);
  onViewHidden("web", () => {
    activeTabId = "";
    window.clearTimeout(placeTimer);
    call(CHANNELS.tabsHide);
  });
  byId("web-home").addEventListener("click", () => call(CHANNELS.tabsHome, activeTabId));
  byId("web-reload").addEventListener("click", () => call(CHANNELS.tabsReload, activeTabId));
  new ResizeObserver(placeActiveTab).observe(byId("web-host"));
  window.addEventListener("resize", placeActiveTab);
  renderTabButtons(await cachedSettings());
}
